import React from 'react';
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { CNavLink } from "../common/Header/c/CHeader";
import QuizCard from "../QuizCard/quizCard";
import { useNextQuizList, useTranslations } from "examsbook-react-sdk/custom-hooks";

/**
 * Next quiz list widget
 */

function NextQuizListWidget() {
    const t = useTranslations();
    const { nextQuizList } = useNextQuizList();

    function onClickNextQuizStart() {
        reactGaEvent("Quiz", "Move Next Quiz");
    }

    return (
        <div className="exam-board card-view">
            <div className="exam-heading">
                <h2 onClick={() => {
                    onClickNextQuizStart();
                }}>{t('next_quizzes')}</h2>
                <CNavLink to="/my-app/tests">{t('view_all')}</CNavLink>
            </div>
            <div className="flexBox-container">
                {
                    nextQuizList && nextQuizList.length ? nextQuizList.map((data, index) => {
                        return (
                            <React.Fragment key={index}>
                                <QuizCard quizData={data} t={t}/>

                            </React.Fragment>
                        );
                    }) : t('COMING_SOON')
                }
            </div>
        </div>
    );
}

export default NextQuizListWidget;
